
const h1Styles = {
    verticalAlign: 'middle',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
};
// The Bluesky butterfly, drawn here for the same reason XIconSVG is: MUI v4's icon set predates it.
const BlueskyIconSVG = () => {
    return (
        // The butterfly fills its 24x24 box edge to edge, where MUI's icons and XIconSVG leave a
        // margin - so it needs padding in the viewBox to sit like the others inside the badge.
        <svg className="MuiSvgIcon-root" focusable="false" viewBox="-4 -4 32 32" aria-hidden="true" style={ h1Styles } >
            <path
                d="M12 10.8C10.913 8.686 7.954 4.747 5.202 2.805 2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"
            />
        </svg>
    );
};
export default BlueskyIconSVG;
